import {useEffect, useState} from "react";
import Popup from "../../../../../../shared/Popup";
import DropDownPurchase from "../../../../../../shared/DropDowns/DropDownPurchase";
import Toaster from "../../../../../../shared/Toaster";
import axios from "axios";
import {PATHS_API} from "../../../../../../../enum";
import {useUserStore} from "../../../../../../../modules/shop/user/store";
import {ToasterProps} from "../../../../../../shared/Toaster/Toaster";
import {getCurrentDateInSeconds} from "../../../../../../shared/functions/getRandomId";
import ButtonLabel from "../../../../../../shared/ButtonLoader/ButtonLoader";
import ProductImage from "../../../../../../shared/ProductImage/ProductImage";
import {useProductsStore} from "../../../../../../../modules/shop/products/store";


const PopupBasketDesc = (props) => {

    const {data, setActivePopup, activePopup, onRemove} = props
    const fetchUser = useUserStore(store => store.fetchUser)

    const [isLoading, setIsLoading] = useState(false)
    const [toastProps, setToastProps] = useState<ToasterProps | null>(null);

    // const [activeServer, setActiveServer] = useState({_id: data._id, name: data.product.productName});
    const [activeServer, setActiveServer] = useState({_id: "placeholder", name: "Виберіть пресет одягу"});
    const products = useProductsStore(state => state.products)
    const fetchProducts = useProductsStore(state => state.fetchProducts)
    const filterProducts = products.filter(p => p.type === "set" && p.personal !== true)

    useEffect(() => {
        fetchProducts()
    }, [])


    const refund = async (_id: string) => {
        if (isLoading) return;

        setIsLoading(true);

        try {
            const { data } = await axios.put(
                PATHS_API.PURCHASES,
                { _id },
                { withCredentials: true }
            );

            setToastProps({
                message: data.message,
                type: "success",
                id: getCurrentDateInSeconds(),
            });

            await fetchUser();
            await onRemove?.();
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message || "Сталася помилка";

            setToastProps({
                message: errorMessage,
                type: "error",
                id: getCurrentDateInSeconds(),
            });
        } finally {
            setIsLoading(false);
            setActivePopup(false);
        }
    };

    const changeSet = async (purchaseId: string, newSet: string) => {
        if(activeServer._id === "placeholder") {
            return setToastProps({
                message: activeServer.name + "!",
                type: "error",
                id: getCurrentDateInSeconds(),
            });
        }
        if (isLoading) return;

        setIsLoading(true);

        try {
            const { data } = await axios.put(
                `${PATHS_API.CHANGE_PURCHASES}`,
                { purchaseId, newSet },
                { withCredentials: true }
            );

            setToastProps({
                message: data.message,
                type: "success",
                id: getCurrentDateInSeconds(),
            });

            await fetchUser();
            await onRemove?.();
        } catch (error: any) {
            const errorMessage =
                error?.response?.data?.message || "Сталася помилка";

            setToastProps({
                message: errorMessage,
                type: "error",
                id: getCurrentDateInSeconds(),
            });
        } finally {
            setIsLoading(false);
            setActivePopup(false);
        }
    };

    return (
        <>
            <Popup
                title={data.product.productName}
                setActivePopup={setActivePopup}
                activePopup={activePopup}
            >
                <div className="card-product-profile">
                    <ProductImage className="product-card-profile product-img" src={data.product.imageUrl} alt="product-img"/>
                    <div className="purchase-info">
                        <p className="desc-product">
                            {
                                data.product.type === "priority" || data.product.type === "set"
                                    ? "Ви можете замінити цей товар на інший. Якщо новий сет дорожчий — спишеться різниця в ціні. Якщо дешевший або такий самий — просто заміна. Доступно один раз на 60 хвилин."
                                    : "Повернути цей товар можна у будь-який час — кошти повернуться на баланс магазину."
                            }
                        </p>
                        <div className="d-flex gap12">
                            <div className="d-flex flex-direction-column">
                                {
                                    data.product.type === "priority" || data.product.type === "set" ||
                                    <button
                                        onClick={() => {
                                            refund(data._id)
                                            setActivePopup(false)
                                        }}
                                        disabled={isLoading}
                                        className={`button-buy change-server-btn ${isLoading ? "btn-loading" : ""}`}
                                    >
                                        <ButtonLabel loading={isLoading}>Зробити повернення товару</ButtonLabel>
                                    </button>
                                }
                                {
                                    data.product.type === "set" &&
                                    <>
                                        <DropDownPurchase
                                            data={filterProducts}
                                            activeOption={activeServer}
                                            setActiveOption={setActiveServer}
                                            width={"100%"}
                                        />
                                        <button style={{marginTop: "10px"}}
                                            onClick={() => {
                                                changeSet(data._id, activeServer._id)
                                                setActivePopup(false)
                                            }}
                                            disabled={isLoading}
                                            className={`button-buy change-server-btn ${isLoading ? "btn-loading" : ""}`}
                                        >
                                            <ButtonLabel loading={isLoading}>Змінити сет</ButtonLabel>
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
            {toastProps && <Toaster message={toastProps.message} type={toastProps.type} id={toastProps.id} />}
        </>
    )
};

export default PopupBasketDesc;